import { dispatchMxView, populateMxStatusMap, beforeStatusChange, afterStatusChange } from '../utils';

export const listenToMxEvents = (): void => {
  window.addEventListener('single-spa:first-mount', populateMxStatusMap);
  window.addEventListener('single-spa:before-app-change', beforeStatusChange);
  window.addEventListener('single-spa:app-change', afterStatusChange);
  window.addEventListener('single-spa:routing-event', dispatchMxView);
};
